import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type { CommendaAiMutationResult } from '../types';
import type { IContinueDocumentReaderRunResponse } from './types';

/** Approves a run held at its cost estimate, so paid reading starts. The backend refuses unless the run is waiting there. */
export async function continueDocumentReaderRun(
  runId: string
): Promise<CommendaAiMutationResult<IContinueDocumentReaderRunResponse>> {
  return AgentApiRequestHelper.mutate<IContinueDocumentReaderRunResponse>(
    `agent-platform/document-reader/runs/${encodeURIComponent(runId)}/continue`,
    { method: 'POST' },
    'Could not start the reading.'
  );
}
